<template>
  <div class="header-container">
    <div class="header">
      <div v-if="styleType === 'red'" class="inner-container container">
        <img v-if="hideLogo !== 'true'" class="logo" src="@/assets/TabbotSecurityLogo.svg" alt="Tabbot Security" />
        <template v-if="hideTimer !== 'true'">
          <div v-if="currentTimer >= 0" class="strikes"><span class="label">{{ $t('common.header.strikes') }}</span><span class="timer">{{ strikeTime }}</span></div>
          <div v-if="currentTimer" class="time"><span class="label">{{ $t('common.header.timeLeft') }}</span><span class="timer">{{ timer }}</span></div>
          <div v-if="currentTimer === 0" class="time"><span class="label">{{ $t('common.header.timeLeft') }}</span><span class="timer">{{ timer }}</span></div>
          <div v-else class="time"> </div>
        </template>
        <div class="flags" v-if="$store.state.languageChoosen">
          <a class="flag_small" @click="switchLocaleToDe"><img src="@/assets/flag_de.svg" alt="deutsch" /></a>
          <a class="flag_small" @click="switchLocaleToEn"><img src="@/assets/flag_en.svg" alt="english" /></a>
        </div>
      </div>
      <div v-else class="inner-container container">
        <img class="logo" src="@/assets/TabbottLogo.svg" alt="Tabbot" />
        <template v-if="hideTimer !== 'true'">
          <div v-if="currentTimer >= 0" class="strikes"><span class="label">{{ $t('common.header.strikes') }}</span><span class="timer">{{ strikeTime }}</span></div>
          <div v-if="currentTimer" class="time"><span class="label">{{ $t('common.header.timeLeft') }}</span><span class="timer">{{ timer }}</span></div>
          <div v-if="currentTimer === 0" class="time"><span class="label">{{ $t('common.header.timeLeft') }}</span><span class="timer">{{ timer }}</span></div>
          <div v-else class="time"> </div>
        </template>
        <div class="flags" v-if="$store.state.languageChoosen">
          <a class="flag_small" @click="switchLocaleToDe"><img src="@/assets/flag_de.svg" alt="deutsch" /></a>
          <a class="flag_small" @click="switchLocaleToEn"><img src="@/assets/flag_en.svg" alt="english" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['currentTimer', 'styleType', 'hideLogo', 'hideTimer', 'strikes'],
  computed: {
    timer: function () {
      if (this.currentTimer > 0) {
        const secondString = '00' + (this.currentTimer - (Math.floor(this.currentTimer / 60) * 60))
        return Math.floor(this.currentTimer / 60) + ':' + (secondString.substr(secondString.length - 2))
      } else {
        return '00:00'
      }
    },
    strikeTime: function () {
      if (!this.strikes) {
        return '00:00'
      }
      let strikes = 0
      for (let r = 0; r < this.strikes.length; r++) {
        for (let s = 0; s < this.strikes[r].length; s++) {
          strikes += this.strikes[r][s]
        }
      }
      if (strikes > 0) {
        const secondString = '00' + (strikes - (Math.floor(strikes / 60) * 60))
        return Math.floor(strikes / 60) + ':' + (secondString.substr(secondString.length - 2))
      } else {
        return '00:00'
      }
    }
  },
  methods: {
    switchLocaleToDe: function () {
      this.$i18n.locale = 'de'
    },
    switchLocaleToEn: function () {
      this.$i18n.locale = 'en'
    }
  }
}
</script>
